import Styled from "styled-components";

export const Container = Styled.div`
`;

export const Banner = Styled.div`
 @media(max-width: 800px) {
  cursor: pointer;
}
.carousel-control-prev-icon{
    background-image: none !important;
}

.carousel-control-next-icon{
    background-image: none !important;
}

.carousel-indicators{
 margin-bottom: -2rem !important;
}

button{
width: 8px !important;
height: 8px !important;
border-radius: 100% !important;
}
`;

export const FeaturedCategoriesBrands = Styled.div`

display:flex;
margin-top: 100px;
justify-content: space-between;
align-items: center;
margin-bottom: 32px;

@media(max-width: 800px) {
  margin-top: 85px;
}

span{
  color: var(--primary-color);
  font-size: 20px;
  font-family: Montserrat;
  font-weight: 400;
  word-wrap: break-word;
}

a, button{
  font-size: 10px;
  font-family: Montserrat;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 10px;
  word-wrap: break-word;
  color: ${(props) => props.theme.whitelabel?.text_primary_color} !important;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
}

img{
  cursor: pointer !important;
}

@media(max-width: 800px) {
  font-size: 14px;
  margin-right: 6px;

}
`;

export const FeaturedSuggested = Styled.div`

display:flex;
margin-top: 100px;
justify-content: space-between;
align-items: center;
margin-bottom: 32px;

@media(max-width: 800px) {
  margin-top: 85px;
}

span{
  color: var(--primary-color);
  font-size: 20px;
  font-family: Montserrat;
  font-weight: 400;
  word-wrap: break-word
}

a{
  font-size: 10px;
  font-family: Montserrat;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 10px;
  word-wrap: break-word
  color: ${(props) => props.theme.primary};
}

img{
  cursor: pointer !important;
}

@media(max-width: 800px) {
  font-size: 14px;
  margin-right: 6px;

}
`;

export const FeaturedProducts = Styled.div`

display:flex;
margin-top: 100px;
justify-content: space-between;
align-items: center;
margin-bottom: 32px;

@media(max-width: 800px) {
  margin-top: 85px;
}

span{
  color: var(--primary-color);
  font-size: 20px;
  font-family: Montserrat;
  font-weight: 400;
  word-wrap: break-word
}

a{
  font-size: 10px;
  font-family: Montserrat;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 10px;
  word-wrap: break-word
  color: ${(props) => props.theme.primary};
}

img{
  cursor: pointer !important;
}

@media(max-width: 800px) {
  font-size: 14px;
  margin-right: 6px;

}
`;

export const Category = Styled.div`
`;

export const Brand = Styled.div`
`;

export const TitleProduct = Styled.p`
 margin-top: 10px;
 font-weight: bold;
 margin-top: 50px;

`;

export const CotainerProduct = Styled.div`
`;

export const Space = Styled.div`
  padding-bottom: 50px;
`;
